export { default as TypographyLabel } from './TypographyLabel'